module.exports = __webpack_public_path__ + "img/covers-03.c1163bdf.png";